module.exports = __webpack_public_path__ + "f69e9bf8e4d297f0109c041197b1aa1a.svg";